import styled from "styled-components"

export const CellPhoneField = styled.div `

  width: 100%;
  display: grid;
  grid-template-columns: 40% 55%;
  column-gap: 5%;

`